<section *ngIf="puntosPageInformacion" class="card">
    <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"></button>
        </ng-template>

    </p-toolbar>
    <p-table [value]="puntoPage" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Puntos</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>

                <td>{{item.puntos}}</td>
                <td></td>
            </tr>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>